import { Component, Input, OnInit } from '@angular/core';
import { StorageService } from '@rct/lynx-lobbies-shared-lib';
import { LYNX_STORAGE_KEYS } from '../../constants/lynx-storage-keys.constant';

@Component({
    selector: 'lynx-amusement',
    templateUrl: './amusement.component.html',
    styleUrls: ['./amusement.component.scss'],
    standalone: false
})
export class AmusementComponent implements OnInit {
  @Input() inCategory: boolean;

  constructor(private storageService: StorageService) {}

  ngOnInit() {}

  amusementText() {
    const lobbyId = this.storageService.get(LYNX_STORAGE_KEYS.lobbyId);

    const hardCodeLobbyId = '74d4789d-d79d-6378-d788-5c5b692d30e4';
    return lobbyId === hardCodeLobbyId ? 'For Amusement Only' : '';
  }
}
